module.exports = __webpack_public_path__ + "static/media/sedeunion.50ecaa8e.jpg";